import { SanitizedText } from '@finn-no/tjt-common-components';
import { useContext } from 'react';
import SidebarContext from 'state/SidebarContext';

const PriceTag = () => {
    const { uiText } = useContext(SidebarContext);

    const {
        tradeTypeText,
        priceText,
        emptyPriceText,
        shippingPrice: { text, altText },
    } = uiText.sections.sidebar.optedIn;

    return (
        <>
            <h2 className=" text-16 md:text-12 text-gray-700 md:text-gray-500 mb-0 mt-8">
                {tradeTypeText}
            </h2>
            <div className="flex content-end mb-4 md:mb-24 mt-4">
                <span className={priceText ? 'h2' : 'h3'}>{priceText || emptyPriceText}</span>

                <SanitizedText
                    text={text}
                    className="flex-grow self-end text-14 ml-8 mb-4"
                    ariaHidden={!!altText}
                />
                {altText && <span className="sr-only">{altText}</span>}
            </div>
        </>
    );
};
export default PriceTag;
